function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: 9,
    y: 25,
    style: {
      fill: "red",
      font: "11px sans-serif"
    }
  }, "\n    Audi\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudi);
export default __webpack_public_path__ + "static/media/audi.8a404a71f168fd1526c71f140e37ecd2.svg";
export { ForwardRef as ReactComponent };